<template>
  <div>
    <label>{{ statusMessage }}</label>
    <table class="table">
      <thead>
      <tr>
        <th>Report ID</th>
        <th>Type</th>
        <th>From</th>
        <th>To</th>
        <th>Email Sent</th>
        <th>Report Created</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="report in computedData" >
        <td>{{ report.id }}</td>
        <td>{{ report.report_type }}</td>
        <td>{{ report.report_from_date }}</td>
        <td>{{ report.report_to_date }}</td>
        <td>{{ report.notified === 0 ? 'No' : 'Yes' }}</td>
        <td>{{ report.created_at }}</td>
        <td>
          <a class="btn btn-xs btn-default" :href="`crm2/${ report.id }/detail`">View Investors</a>
          <a class="btn btn-xs btn-default" @click="sendEmail($event,report.id)" >{{ sendBtnName(report) }}</a>
        </td>
      </tr>
      </tbody>
    </table>
    <confirm-modal :show-confirm="showConfirm" confirm-message="Do you want to email this report?" @ok="confirmReport" @cancel="cancelReport"></confirm-modal>
  </div>
</template>

<script>
import axios from "axios";
import ConfirmModal from "../ConfirmModal";

export default {
  name: "ReportsIndex",
  components: {ConfirmModal},
  props: {
    reportData: Array,
    default: []
  },
  data() {
    return {
      showConfirm: false,
      statusMessage: '',
      formData: {
        reportId: 0,
      },
      showStatusMessage: false,
      reports: this.reportData,
    }
  },
  computed: {
    computedData() {
      let report = []
      report = this.reports
      return report
    },
  },
  methods: {
    sendEmail(event,id) {
      event.preventDefault()
      this.showConfirm = true
      this.formData.reportId = id
      this.timer()
    },
    sendReport() {
      axios.post('crm2/send', this.formData)
          .then(response => {
            this.statusMessage = response.data.statusMessage
            this.reports = response.data.reportEvents
            this.timer()
            return Promise.resolve()
          })
    },
    confirmReport: function () {
      this.showConfirm = false
      this.statusMessage = "Your report is being emailed."
      this.showStatusMessage = true
      this.sendReport()
      this.timer()
    },
    cancelReport: function () {
      this.showConfirm = false
      this.statusMessage = "Emailing of your report has been cancelled."
      this.showStatusMessage = true
      this.timer()
    },
    timer() {
      setTimeout(() => {
        this.showStatusMessage = false
        this.statusMessage = ''
      }, 5000)
    },
    sendBtnName(report) {
      if(report.notified === 0) {
        return 'Send All Emails'
      }
      return 'ReSend All Emails'
    }
  }
}
</script>